import Loadable from "react-loadable";

const LazyListCandidates = Loadable({
  loader: () => import(/* webpackChunkName: 'list-candidates' */ "./index"),
  loading: () => 'loading...'
});

export default LazyListCandidates;
